/**
 * Couts mensuels recurrents : le calcul d'une ligne, en un seul endroit.
 *
 * `monthlyCost` est le prix UNITAIRE. Le total d'une ligne vaut
 * quantity * monthlyCost, et ce calcul est lu a onze endroits — editeur,
 * resume financier, PDF, templates, contexte envoye au modele. Onze copies,
 * c'est onze occasions d'en oublier une, et un total faux part chez le client.
 *
 * Ce fichier existe en deux exemplaires, serveur et interface, faute de module
 * partage dans ce depot. `tests/couts.test.js` verifie qu'ils rendent la meme
 * chose sur les memes entrees : c'est la divergence qui est dangereuse, pas la
 * duplication.
 */

/** Total mensuel d'une ligne. Une quantite absente ou invalide vaut 1. */
export const coutMensuelLigne = (cout) => {
  if (!cout) return 0;
  const q = Number(cout.quantity);
  const quantite = Number.isFinite(q) && q > 0 ? q : 1;
  const prix = Number(cout.monthlyCost);
  return quantite * (Number.isFinite(prix) ? prix : 0);
};

/**
 * Faut-il montrer « 33 x 5,67 $ » au client ?
 * Jamais a l'unite : « 1 x » serait du bruit, et c'est l'affichage d'avant.
 */
export const afficheQuantite = (cout) =>
  Boolean(cout) && cout.showQuantity !== false && Number(cout.quantity) > 1;

/**
 * Quantite normalisee pour l'ECRITURE : un entier >= 1.
 *
 * Zero n'est jamais une quantite valide — stocke, il donnerait une ligne a
 * zero dollar sur un devis client. Les quatre chemins d'ecriture passent par
 * ici ; quatre copies divergeaient deja sur l'entree 0,5.
 */
export const normaliserQuantite = (valeur) => {
  const n = Math.trunc(Number(valeur));
  return Number.isFinite(n) && n > 0 ? n : 1;
};

export default coutMensuelLigne;
